module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    attrs: {
      "type": "text",
      "data-uk-timepicker": _vm.options
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bb261d9a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UkTimepicker.vue
// module id = 300
// module chunks = 2